import React, {Component} from "react";
import SimpleBar from "../../libs/simplebar";
import Common from "../../utils/common";
import Analytics from "../../libs/analytics";
import PhotoProducts from "../PhotoProducts/PhotoProducts";
import PhotoProductModal from "../PhotoProductModal/PhotoProductModal";
import "./Products.scss";
import ConfigurationHelper from "../../configuration/ClientConfigurationHelper";
import store from "../../store/store";
import * as actionType from "../../store/actions";

class Products extends Component {
    state = {
        mandatoryClass: this.getMandatoryClass(),
        modalContent: null,
        modalOpen: false,
        selectedIndex: null,
        enableNext: false,
        enablePrev: false
    }
    setMandatoryClass = () => {
        const mandatoryClass = this.getMandatoryClass();
        this.resizeProductHolder(mandatoryClass);
        this.setState({
            mandatoryClass: mandatoryClass
        })
    }

    getMandatoryClass() {
        return window.innerWidth > 991 ? "y-scroll" : "x-scroll";
    }

    offsetTop(element) {
        return element.getBoundingClientRect().top + document.body.scrollTop;
    }


    productClick = (product, e) => {
        e.preventDefault();
        e.stopPropagation();
        const {userHashId} = this.props;
        const {id} = this.props.asset;
        if(!userHashId || !ConfigurationHelper.useAffiliateProductsLink()){
            Analytics.productClick(product, id);
			Analytics._GA_EVENTS('event',{
				'Event_category' : 'videos',
				'Event_action': 'tvp:product:click',
				'Event_label' : product.title
			});
        }
        return e;
    }

    renderProduct = (product, index) => {
        const {id} = this.props.asset;
        const {userHashId} = this.props;
        return <li key={index}>
            <a href={Common.getProductLink(product, id, userHashId)} onClick={(e)=>{e.stopPropagation(); e.preventDefault();this.openModal(index)}}
               target="_blank">
                <div id={`p-${index}`} className="product">
                    <div className="product-img"
                         style={{backgroundImage: `url(data:image/gif;base64,R0lGODlhAQABAIAAAP///////yH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==)`}}>
                        <img src={`${product.imageUrl}`} alt={product.title}/>
                        <div className={"product-cta-text"}>{ConfigurationHelper.getProductsCTAText()}</div>
                    </div>
                </div>
            </a>
        </li>
    }
    componentDidMount() {
        const wrapper = document.getElementById("scroller-wrapper");
        const scroller = new SimpleBar(wrapper);
        window.addEventListener("resize", this.setMandatoryClass);
        this.setMandatoryClass();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.setMandatoryClass, false);
    }

    resizeProductHolder = (mandatoryClass) => {
        const productsHolder = document.querySelector(".products-holder1");
        const productsWrapper = productsHolder.querySelector("#scroller-wrapper");
        if ("y-scroll" === mandatoryClass) {
            const playerEl = document.getElementById("tvpageplayer-wrapper");
            const productHolderNewHeight = playerEl.getBoundingClientRect().height;
            productsHolder.style.height = (productHolderNewHeight) + "px";
            productsWrapper.style.height = (productHolderNewHeight - 10) + "px";
        } else {
            productsHolder.style.height = null;
            productsWrapper.style.height = null;
        }
    }
    getOtherProduct = (next) => {
        this.setProductActive(next)
    }
    openModal = (key) => {
        this.setProductActive(key)
    }
    setProductActive = (key) => {
        const {products, asset, userHashId} = this.props;
        const product = products[key];
        Analytics.productClick(product, product.entityIdParent);
        store.dispatch({
            type: actionType.UPDATE_PRODUCT_MODAL,
            product_modal: {
                modalOpen: true,
                product: product,
                selectedIndex: key,
                enableNext: this.enableNext(products[key + 1]),
                enablePrev: this.enablePrev(products[key - 1]),
                asset: asset,
                userHashId: userHashId
            }
        });
    }

    enableNext(next) {
        if (!next) return false;
        return (next && !next.dummy)
    }

    enablePrev(prev) {
        if (!prev) return false;
        return (prev && !prev.dummy)
    }

    render() {
        const {products, asset} = this.props;
        const {modalOpen, mandatoryClass, modalContent, enableNext, enablePrev, selectedIndex} = this.state;
        let dynamicStyle = {};
        if (mandatoryClass === "x-scroll") {
            dynamicStyle = {
                width: (93 * products.length) + "px"
            }
        }

        return <div id={"desktop-products"} className="col-12 col-lg-2">
            <div className={"products-wrapper"}>
                <div className={"products-holder1"}>

                    <div id={"scroller-wrapper"} className={mandatoryClass}>
                        <div id={"scroller"} style={dynamicStyle}>
                            <ul id="desktop-products-list">
                                {products && products.map(this.renderProduct)}
                            </ul>
                        </div>
                    </div>
                    {(mandatoryClass === "x-scroll" && products.length > 0) && <PhotoProducts asset={asset} products={products}/>}
                </div>
                <PhotoProductModal
                    getNewProduct={this.getOtherProduct}/>
            </div>
        </div>
    }
}

Products.defaultProps = {
    products: []
};
export default Products;